<template>
  <div
    class="neutral tone-100 full-screen"
    v-bind="$attrs"
  >
    <BaseCard
      class="neutral tone-100 px-2"
      :hideDivider="hideDivider"
    >
      <template #header>
        <div class="py-4 d-flex">
          <BaseButton
            :ripple="false"
            depressed
            color="transparent"
            @click="$emit('close')"
            :height="32"
            class="px-0 mr-4"
            :style="{'min-width': '0px'}"
            small
          >
            <font-awesome-icon
              icon="fa-regular fa-arrow-left"
              class="brand-secondary--text"
              size="lg"
            />
          </BaseButton>
          <slot name="header" />
        </div>
      </template>

      <template #content>
        <slot name="content" />

        <div
          class="sticky-bottom neutral tone-100 pb-7"
          v-if="submitButtonText"
        >
          <slot name="bottom-text" />
          <v-divider class="neutral tone-200 mb-4" v-if="!hideBottomButtonDivider"/>
          <BaseButton
            color="brand-primary tone-400 w-100"
            @click="$emit('confirm')"
            :height="56"
          >
            <div class="white--text text-body-m-bold">
              {{ submitButtonText }}
            </div>
          </BaseButton>
        </div>
      </template>
    </BaseCard>
  </div>
</template>

<script>
import BaseCard from '@/components/BaseCard.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  components: {
    BaseCard,
    BaseButton,
  },
  props: {
    hideDivider: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      required: false,
    },
    hideBottomButtonDivider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

.full-screen {
  height: 100vh;
  width: 100vw;
  z-index: 150;
}

.v-btn--outlined {
  background-color: var(--v-white-base);
  border-width: 1px;
}

</style>
